module.exports = __webpack_public_path__ + "static/media/03.b1f392da.png";